export interface SalesIssue {
    id: number;
    subject: string;
    status: string;
    start_date: Date;
    acv_value: number;
    setup: number;
    mrr: number;
    pipeline_stage: string;
    win_probability: string;
    lead_source: string;
    last_update_text: string;
    last_update_date: string;
    estimated_close_date: string;
    next_action_date: string;
    opportunity_owner: string;
}

export function SalesIssueFromJSON(json: any): SalesIssue {
    return {
        id: json["id"],
        subject: json["subject"],
        status: json["status"],
        start_date: new Date(json["start_date"]),
        acv_value: json["acv_value"],
        setup: json["setup"],
        mrr: json["mrr"],
        pipeline_stage: json["pipeline_stage"],
        win_probability: json["win_probability"],
        lead_source: json["lead_source"],
        last_update_text: json["last_update_text"],
        last_update_date: json["last_update_date"],
        estimated_close_date: json["estimated_close_date"],
        next_action_date: json["next_action_date"],
        opportunity_owner: json["opportunity_owner"],
    }
}
